<template>
  <a-form-item :label="label">
    <a-select
      :getPopupContainer="(triggerNode) => triggerNode.parentNode"
      v-model:value="selected"
      class="select"
    >
      <a-select-option :key="0">Gestionados y sin gestionar</a-select-option>
      <a-select-option :key="1" value="True"> Gestionados </a-select-option>
      <a-select-option :key="2" value="False"> Sin gestionar </a-select-option>
    </a-select>
  </a-form-item>
</template>

<script>
export default {
  props: {
    value: {
      required: true,
      type: Number,
    },
    label: {
      required: false,
      type: String,
      default: "",
    },
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("update:value", value);
      },
    },
  },
};
</script>

<style lang="sass" scoped>
.select
  width: 180px
</style>
